import type { SVGProps } from "react"
import React from "react"

export const Pinterest: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 32,
  height = 32,
  fill = "#000",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Pinterest icon</title>
    <path
      fill={fill}
      d="M16.8055 4C11.8547 4 7 7.26849 7 12.6038C7 15.9684 8.87457 17.8911 10.0282 17.8911C10.5088 17.8911 10.7972 16.5933 10.7972 16.2088C10.7972 15.7762 9.64363 14.8148 9.64363 12.9403C9.64363 9.09499 12.5757 6.35523 16.3729 6.35523C19.6894 6.35523 22.0927 8.22981 22.0927 11.6425C22.0927 14.19 21.0833 18.9485 17.7668 18.9485C16.5651 18.9485 15.5077 18.0833 15.5077 16.8817C15.5077 15.0552 16.8055 13.2767 16.8055 11.4022C16.8055 8.22981 12.2873 8.8066 12.2873 12.6519C12.2873 13.469 12.3834 14.3342 12.7679 15.1032C12.095 17.9391 10.7491 22.217 10.7491 25.149C10.7491 26.0623 10.8453 26.9275 10.9414 27.8407C11.0856 28.033 11.0375 28.033 11.2779 27.9369C13.6812 24.6203 13.6331 23.9474 14.6906 19.6214C15.3154 20.727 16.8055 21.3518 18.0552 21.3518C23.1502 21.3518 25.4573 16.353 25.4573 11.8828C25.4573 7.12429 21.3237 4 16.8055 4Z"
    />
  </svg>
)
